import * as React from 'react';
import { MainContentWrapper } from 'components';

import { useStyles } from './Layout.styles';

type LayoutProps = {
  header?: React.ReactNode;
  main?: React.ReactNode;
};

const Layout: React.FC<LayoutProps> = ({ header, main }) => {
  const styles = useStyles();
  return (
    <MainContentWrapper>
      <section className={styles.root}>
        <div className={styles.content}>
          {header &&
            <header className={styles.header}>{header}</header>
          }
          {main &&
            <main className={styles.main}>
              <section className={styles.container}>{main}</section>
            </main>
          }
        </div>
      </section>
    </MainContentWrapper>
  );
};

export default Layout;
